export let CLINICAL = 'CLINICAL';
export let BIOSPECIMEN = 'BIOSPECIMEN';

export let UPLOADING = 'UPLOADING';
export let NOT_VALIDATED = 'NOT_VALIDATED';
export let PENDING = 'PENDING';
export let VALID = 'VALID';
export let SUBMITTED = 'SUBMITTED';
export let INVALID = 'INVALID';
export let ERROR = 'ERROR';
